module.exports = __webpack_public_path__ + "img/map-bg-small.29265cb2.svg";